exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disambiDest{margin:10px;padding:10px;transition:.5s;box-shadow:0 0 2px 2px hsla(0,0%,58.8%,.2);-moz-box-shadow:0 0 2px 2px hsla(0,0%,58.8%,.2);-webkit-box-shadow:0 0 2px 2px hsla(0,0%,58.8%,.2)}.disambiDest:hover{cursor:pointer;box-shadow:0 0 2px 2px #e8b543;-moz-box-shadow:0 0 2px 2px #e8b543;-webkit-box-shadow:0 0 2px 2px #e8b543}", ""]);

// exports
